import {ContactLevel,FormFieldConfig,Template,TemplateCategory,} from "./shared-interfaces";

interface BuildTemplateFormFieldsArgs {
  contactLevels: ContactLevel[];
  templateCategories: TemplateCategory[];
  template?: Partial<Template>;
  body?: string;
  templateContactLevelsIDs?: string[];
  templateCcContactLevelsIDs?: string[];
}

export const templateTypeOptions = [
  { name: "Pdf", id: "pdf" },
  { name: "Email", id: "email" },
  { name: "SMS", id: "sms" },
];

export function buildTemplateFormFields({
  contactLevels,
  templateCategories,
  template,
  body,
  templateContactLevelsIDs = [],
  templateCcContactLevelsIDs = [],
}: BuildTemplateFormFieldsArgs): FormFieldConfig[] {
  return [
    {
      name: "name",
      label: "Template Name",
      inputType: "string",
      placeholder: "Template Name",
      rule: "string",
      initialValue: template?.name,
      required: true,
      colConfig: {
        span: 24,
      },
    },
    {
      name: "templateCategoryId",
      label: "Template Category",
      inputType: "select",
      placeholder:
        templateCategories.length > 0 ? "Select template category" : "N/A",
      rule: "string",
      initialValue: template?.templateCategory?.id,
      selectOptions: templateCategories,
      required: false,
      colConfig: {
        span: 24,
      },
    },
    {
      name: "templateType",
      label: "Template Type",
      inputType: "select",
      placeholder: "Template Type",
      rule: "string",
      selectOptions: templateTypeOptions,
      initialValue: template?.templateType,
      required: true,
      colConfig: {
        span: 24,
      },
    },
    {
      name: "emailSubject",
      label: "Subject",
      inputType: "string",
      placeholder: "Subject",
      rule: "string",
      initialValue: template?.emailSubject,
      required: true,
      colConfig: {
        span: 24,
      },
    },
    {
      name: "body",
      label: "Body",
      inputType: "textArea",
      placeholder: "",
      rule: "string",
      initialValue: body || template?.body,
      required: true,
      colConfig: {
        span: 24,
      },
    },
    {
      id: "contactLevelIds",
      name: "contactLevelIds",
      inputType: "multipleSelect",
      isArrayField: true,
      label: "Select Contact Level",
      rule: "string",
      placeholder: "Contact Level",
      initialValue: templateContactLevelsIDs,
      required: false,
      colConfig: {
        span: 24,
      },
      selectOptions: contactLevels,
    },
    {
      id: "ccContactLevelIds",
      name: "ccContactLevelIds",
      inputType: "multipleSelect",
      isArrayField: true,
      label: "Select CC Contact Level",
      rule: "string",
      placeholder: "Contact Level",
      initialValue: templateCcContactLevelsIDs,
      required: false,
      colConfig: {
        span: 24,
      },
      selectOptions: contactLevels,
    },
  ];
}
